<template>
    <div class="QuestiongroupSeting">
        <a-card class="card" title="基本设置" :bordered="false">
            <BaseSet ref="BaseSet" @changeType="changeType"></BaseSet>
        </a-card>
        <a-card class="card" title="能力设置" :bordered="false" style="margin-top: 20px;" v-if="type == 'edit'">
            <AblitySet></AblitySet>
        </a-card>

    </div>
</template>

<script>

import BaseSet from "./components/BaseSet";
import AblitySet from "./components/AblitySet";
// import VersionsSet from "./components/VersionsSet";
import $Bus from "@/pages/projectImpl/js/eventBus"

export default {
    name: 'QuestiongroupSeting',
    components: {BaseSet, AblitySet},
    data() {
        return {
            type:  this.$store.getters["content/getQuestionGroupInfo"]() ? 'edit' : 'add',
        }
    },
    mounted() {
        this.setTitle()
    },
    methods: {
        // 设置当前页面title
        setTitle() {
            const info = this.$store.getters["content/getQuestionGroupInfo"]();
            let arr = ["首页", "内容中心", {name: "题目壳管理", path: info.fullPath || "/content/Questiongroup"}, "题目壳配置"];
            let tabName = "题目壳配置"
            if (this.$route.query.contentType == 5) {
                arr = ["首页", "内容中心", {name: "亲子游戏管理", path: info.fullPath ||  "/content/ParentingGame?PageIndex=1&PageSize=10&ContentType=5"}, "亲子游戏配置"];
                tabName = "亲子游戏配置";
            }
            if (this.type == "edit") {
                let currentName = info.contentName;
                let versionName = info.versionName;
                tabName = `${currentName}${versionName ? ' - ' + versionName : ''} 配置`
            }
            // $Bus.$emit("pageHeaderTitle", tabName);
            // $Bus.$emit("updateTabName", {path: this.$route.path, name: tabName});
            // $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
        // 接收子组件传参
        changeType(val) {
            this.type = val
            setTimeout(() => {
                this.setTitle()
            }, 100)
        },
    },
    beforeDestroy() {
        $Bus.$emit("pageHeaderTitle", false);
    }
}
</script>

<style scoped lang="less">
.QuestiongroupSeting {
    width: 100%;
    height: 100%;
}
</style>
